const TicketNewCommentBadge = () => {
  return (
    <div
      className="mx-auto w-[145px] rounded-lg bg-neutral-4 text-center font-light text-neutral-11 text-sm"
      data-testid="new-messages-indicator"
    >
      Neue Nachrichten
    </div>
  );
};

export default TicketNewCommentBadge;
